import { ReactElement } from 'react';
import {
  IDeaNumUser,
  certStatusLabel,
  formatDate,
  mailTo,
  mapRole,
} from '../common';

export const show = (value: keyof IDeaNumUser) => (a: IDeaNumUser) => a[value];

export const showDetails =
  (a: IDeaNumUser | undefined) =>
  (key: keyof IDeaNumUser): string | ReactElement[] | undefined => {
    if (a === undefined) {
      return '';
    }
    if (key === 'idExpirationDt') {
      return a.idExpirationDt ? formatDate(new Date(a.idExpirationDt)) : 'n/a';
    }
    if (key === 'deaExpDt') {
      return a.deaExpDt ? formatDate(new Date(a.deaExpDt)) : 'n/a';
    }
    if (key === 'certExpDt') {
      return a.certExpDt ? formatDate(new Date(a.certExpDt)) : 'n/a';
    }
    if (key === 'numberOfRenewal') {
      return ('' + a.renewalInstNo) as string;
    }
    if (key === 'address') {
      const { city, postalCd, stateCd, street1, street2, street3 } = a;
      return mailTo({ city, postalCd, stateCd, street1, street2, street3 });
    }
    if (key === 'status') {
      return a.active ? 'Active' : 'Inactive';
    }
    if (key === 'role') {
      return mapRole(a.role);
    }
    if (key === 'certStatus') {
      return certStatusLabel(a.certStatus);
    }
    return a[key] as string;
  };
